module.exports = __webpack_public_path__ + "static/img/02.348fbad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/02.jpg
// module id = d07Y
// module chunks = 1